import api from '../../../app/api';
import { RequestDetails } from '../models/request-details';

export const requestsApi = api
  .enhanceEndpoints({
    addTagTypes: ['Request', 'FileUpload'],
  })
  .injectEndpoints({
    endpoints: builder => {
      return {
        getRequest: builder.query<RequestDetails, string>({
          query: requestId => ({
            url: `/portal-api/v1/requests/${requestId}`,
          }),
          providesTags: ['Request', 'FileUpload'],
        }),
      };
    },
    overrideExisting: false,
  });

export const { useGetRequestQuery } = requestsApi;
